import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

const useSmallScreen = () => {
  return useMediaQuery(useTheme().breakpoints.down('md'));
};

export default useSmallScreen;
